import { push } from './core';
import { formatTrackingListName } from './format';
import { formatSale, type TrackingSale } from './saleFormat';
import { useTrackingGlobalSale, useTrackingGlobalSales, useTrackingReferralListName } from './state';

import { type OrderEntity } from '~/apiClient';
import type { PlatformSaleItemEntity } from '~/types/sale.type';

export const pushWithGlobalSale = (
    buildPayload: (sales: TrackingSale[], sale: PlatformSaleItemEntity) => Record<string, any>,
    options: { value?: number; addServices?: OrderEntity } = {}
): void => {
    const sale = useTrackingGlobalSale().value;
    if (!sale) return;

    push(buildPayload([formatSale(sale, 0, useTrackingReferralListName().value, options)], sale));
};

export const pushWithGlobalSales = (buildPayload: (sales: TrackingSale[], listName: string | null) => Record<string, any>): void => {
    const sales = useTrackingGlobalSales().value ?? [];
    const listName = formatTrackingListName('page');

    push(
        buildPayload(
            sales.map((sale, index) => formatSale(sale, index, listName)),
            listName
        )
    );
};
